var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.tabsData.length > 0
    ? _c(
        "div",
        [
          _c("LexonBreadcrumbsComponent", {
            attrs: { items: _vm.breadcrumbsItems },
            on: { "clicked-item": _vm.closeTabsEvent },
          }),
          _c("LfHeaderTitle", {
            staticClass: "header-title",
            attrs: {
              title: _vm.getHeaderTitle,
              buttons: _vm.buttons,
              executeAction: _vm.onExecuteAction,
            },
          }),
          _c("TabsComponent", {
            ref: "tabsComponent",
            attrs: {
              tabs: _vm.tabsData,
              context: this.context,
              autoRefreshForm: _vm.autoRefreshForm,
              entity: _vm.entity,
              forceSaveProp: false,
            },
            on: { "changed-tab": _vm.onTabChange },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }